import { render, staticRenderFns } from "./OrderStatusSelect.vue?vue&type=template&id=016bdb74"
import script from "./OrderStatusSelect.vue?vue&type=script&lang=ts"
export * from "./OrderStatusSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports